/**
 * Scroll Animations
 * Uses Intersection Observer API for performant scroll-triggered animations
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Check if browser supports Intersection Observer
  if (!('IntersectionObserver' in window)) {
    // Fallback: Just show all elements
    const animatedElements = document.querySelectorAll('[class*="animate-"]');
    animatedElements.forEach(el => el.classList.add('is-visible'));
    return;
  }

  // Intersection Observer options
  const observerOptions = {
    root: null, // Use viewport
    rootMargin: '0px 0px -100px 0px', // Trigger 100px before element enters viewport
    threshold: 0.1 // Trigger when 10% of element is visible
  };

  // Callback function when element intersects
  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add 'is-visible' class to trigger animation
        entry.target.classList.add('is-visible');
        
        // Optional: Stop observing after animation (one-time animation)
        // Uncomment next line if you want animation to trigger only once
        // observer.unobserve(entry.target);
      }
    });
  };

  // Create observer
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // Find all elements with animation classes and observe them
  const animatedElements = document.querySelectorAll(
    '.animate-on-scroll, .animate-fade-in, .animate-slide-up, .animate-slide-left, .animate-slide-right, .animate-scale, .animate-stagger'
  );

  animatedElements.forEach(el => {
    observer.observe(el);
  });

  // Console log for debugging (remove in production)
  if (animatedElements.length > 0) {
    console.log(`Scroll animations initialized: ${animatedElements.length} elements`);
  }
});

